// External dependencies
import jQuery from 'jquery';

jQuery(document).ready(function ($) {
    /**
     * Button class - Handle both header and sidebar download buttons
     */
    $('.promo-downloadable-popup').on('click', function(e) {
        e.preventDefault();
        
        // Determine which form to show based on which button was clicked
        if ($(this).closest('.header-promo-txt-wrapper').length) {
            $('body').addClass('header-downloadable-form-show');
            prefillForm('header');
        } else {
            $('body').addClass('sidebar-downloadable-form-show');
            prefillForm('sidebar');
        }
    });

    /**
     * Form Close action for both forms
     */
    $('.close-popup-form').on('click', function() {
        $('body').removeClass('header-downloadable-form-show sidebar-downloadable-form-show');
    });

    /**
     * Close forms when clicking outside
     */
    $('section.downloadable-form-section').on('click', function(e) {
        const popContainer = $(this).find('.popup-form-inner');
        if (!popContainer.is(e.target) && popContainer.has(e.target).length === 0) {
            if ($(this).hasClass('header-downloadable-form')) {
                $('body').removeClass('header-downloadable-form-show');
            } else if ($(this).hasClass('sidebar-downloadable-form')) {
                $('body').removeClass('sidebar-downloadable-form-show');
            }
        }
    });

    /**
     * Prefill form with saved data
     */
    function prefillForm(formType) {
        const formSection = $('.' + formType + '-downloadable-form');
        
		formSection.find(input[type="email"]).val('');

        // Get cookie values
        // const nameCookie = getCookie(formType + '_df_form_name_cookie');
        const emailCookie = getCookie(formType + '_df_form_email_cookie');
        // const phoneCookie = getCookie(formType + '_df_form_phone_cookie');
        // const companyNameCookie = getCookie(formType + '_df_form_company_name_cookie');
        // const companyWebsiteCookie = getCookie(formType + '_df_form_company_website_cookie');
        
        // Pre-fill form fields
        // if (nameCookie) formSection.find('input[name="first_name"]').val(nameCookie);
        if (emailCookie) formSection.find('input[name="email"]').val(emailCookie);
    //     if (phoneCookie) formSection.find('input[name="cf-phone-number"]').val(phoneCookie);
    //     if (companyNameCookie) formSection.find('input[name="company_name"]').val(companyNameCookie);
    //     if (companyWebsiteCookie) formSection.find('input[name="company_website"]').val(companyWebsiteCookie);
     }

    /**
     * Handle form submission for both forms
     */
    document.addEventListener('wpcf7mailsent', function(event) {
        // Get the form element
        const formElement = document.querySelector('#' + event.detail.unitTag);
        
        if (formElement) {
            // Get the parent form section
            const formSection = $(formElement).closest('section.downloadable-form-section');
            const formType = formSection.hasClass('header-downloadable-form') ? 'header' : 'sidebar';
            
            // Get form data
            const downloadableFileName = formSection.attr('filename');
            const downloadableFileUrl = formSection.attr('d-url');
            // const downloadableFormName = formSection.find('input[name="first_name"]');
            const downloadableFormEmail = formSection.find('input[name="email"]');
            // const downloadableFormPhone = formSection.find('input[name="cf-phone-number"]');
            // const downloadableFormCompanyName = formSection.find('input[name="company_name"]');
            // const downloadableFormCompanyWebsite = formSection.find('input[name="company_website"]');

            // Look for the wrapper with data-title
            const formWrapper = formElement.closest('.contact-form');
            const formTitle = formWrapper ? formWrapper.getAttribute('data-title') : null;

            // Match by title
            if (formTitle === 'Downloadable Form') {
                // Set cookies with type prefix to distinguish between forms
                // setCookie(formType + '_df_form_name_cookie', downloadableFormName.val(), 365);
                setCookie(formType + '_df_form_email_cookie', downloadableFormEmail.val(), 365);
                // setCookie(formType + '_df_form_phone_cookie', downloadableFormPhone.val(), 365);

                // Optional fields
                // const companyNameVal = downloadableFormCompanyName.val();
                // const companyWebsiteVal = downloadableFormCompanyWebsite.val();

                // if (companyNameVal) {
                //     setCookie(formType + '_df_form_company_name_cookie', companyNameVal, 365);
                // }
                // if (companyWebsiteVal) {
                //     setCookie(formType + '_df_form_company_website_cookie', companyWebsiteVal, 365);
                // }

                // Download file
                $.ajax({
                    url: downloadableFileUrl,
                    method: 'GET',
                    xhrFields: { responseType: 'blob' },
                    success(data) {
                        const a = document.createElement('a');
                        const url = window.URL.createObjectURL(data);
                        a.href = url;
                        a.download = downloadableFileName;
                        document.body.append(a);
                        a.click();
                        a.remove();
                        window.URL.revokeObjectURL(url);


						// ✅ Reset form after success
						formElement.reset();
						formSection.find(input[type="email"]).val('');

                    },
                });
            }
        }
    }, false);

    // Cookie functions
    function getCookie(cname) {
        const name = cname + '=';
        const decodedCookie = decodeURIComponent(document.cookie);
        const ca = decodedCookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i];
            while (c.charAt(0) === ' ') {
                c = c.substring(1);
            }
            if (c.indexOf(name) === 0) {
                return c.substring(name.length, c.length);
            }
        }
        return '';
    }
    
    function setCookie(cname, cValue, exDays) {
        const d = new Date();
        d.setTime(d.getTime() + (exDays * 24 * 60 * 60 * 1000));
        const expires = 'expires=' + d.toUTCString();
        document.cookie = cname + '=' + cValue + ';' + expires + ';path=/';
    }
});